<div class="progress-container" fxLayout="row">
	<div *ngIf="stop?.type === 'ROUTESTOP'" [ngClass]="{'status-complete' : stop?.arrivalTime?.formattedDate}"
		 class="progress-box" fxFlex="50" fxLayoutAlign="center center">
		<div>Arrived
			<div class="small-text">
				<div *ngIf="stop?.arrivalTime?.formattedDate">
					{{stop?.arrivalTime?.formattedDate}} {{stop?.arrivalTime?.formattedTime}} {{stop?.arrivalTime?.timeZone}}
				</div>
				<div *ngIf="!stop?.arrivalTime?.formattedDate && !stop?.pickupEta?.formattedDate">
					{{stop?.statusDescription !== 'CANCELED' && !stop?.completedTime?.formattedDate && user?.globalSettings?.customMessageForNullPickedup ? user?.globalSettings?.customMessageForNullPickedup : 'N/A'}}
				</div>
				<div *ngIf="!stop?.arrivalTime?.formattedDate && stop?.pickupEta?.formattedDate && user?.token">
					ETA: {{stop?.pickupEta?.formattedDate}} {{stop?.pickupEta?.formattedTime}} {{stop?.pickupEta?.timeZone}}
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="stop?.type === 'ROUTESTOP'" [ngClass]="{'status-complete' : stop?.completedTime?.formattedDate, 'status-cancelled' : stop?.statusDescription === 'CANCELED'}"
		 class="progress-box"
		 fxFlex="auto" fxLayoutAlign="center center">
		<div>{{stop?.statusDescription === 'CANCELED' ? 'Cancelled' : 'Completed'}}
			<div class="small-text">
				<div *ngIf="stop?.completedTime?.formattedDate">
					{{stop?.completedTime?.formattedDate}} {{stop?.completedTime?.formattedTime}} {{stop?.completedTime?.timeZone}}
				</div>
				<div *ngIf="!stop?.completedTime?.formattedDate && !stop?.deliverEta?.formattedDate">
					{{stop?.statusDescription !== 'CANCELED' && user?.globalSettings?.customMessageForNullDelivered ? user?.globalSettings?.customMessageForNullDelivered : 'N/A'}}
				</div>
				<div *ngIf="!stop?.completedTime?.formattedDate && stop?.deliverEta?.formattedDate && user?.token">
					ETA: {{stop?.deliverEta?.formattedDate}} {{stop?.deliverEta?.formattedTime}} {{stop?.deliverEta?.timeZone}}
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="stop?.type === 'ONDEMAND'" [ngClass]="{'status-complete' : stop?.ordered?.formattedDate}"
		 class="progress-box" fxFlex="33" fxLayoutAlign="center center">
		<div>{{'trackOrderDetailsView.orderedLabel' | translate}}
			<div class="small-text">
				<div *ngIf="stop?.ordered?.formattedDate">
					{{stop?.ordered?.formattedDate}} {{stop?.ordered?.formattedTime}} {{stop?.ordered?.timeZone}}
				</div>
				<div *ngIf="!stop?.ordered?.formattedDate">N/A</div>
			</div>
		</div>
	</div>
	<div *ngIf="stop?.type === 'ONDEMAND'" [ngClass]="{'status-complete' : stop?.pickedUp?.formattedDate}"
		 class="progress-box" fxFlex="33" fxLayoutAlign="center center">
		<div>{{'trackOrderDetailsView.pickedUpLabel' | translate}}
			<div class="small-text">
				<div *ngIf="stop?.pickedUp?.formattedDate">
					{{stop?.pickedUp?.formattedDate}} {{stop?.pickedUp?.formattedTime}} {{stop?.pickedUp?.timeZone}}
				</div>
				<div *ngIf="!stop?.pickedUp?.formattedDate && !stop?.pickupEta?.formattedDate">
					{{stop?.statusDescription !== 'CANCELED' && !stop?.delivered?.formattedDate && user?.globalSettings?.customMessageForNullPickedup ? user?.globalSettings?.customMessageForNullPickedup : 'N/A'}}
				</div>
				<div *ngIf="!stop?.pickedUp?.formattedDate && stop?.pickupEta?.formattedDate && user?.token">
					ETA: {{stop?.pickupEta?.formattedDate}} {{stop?.pickupEta?.formattedTime}} {{stop?.pickupEta?.timeZone}}
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="stop?.type === 'ONDEMAND'" [ngClass]="{'status-complete' : stop?.delivered?.formattedDate, 'status-canceled' : stop?.statusDescription === 'CANCELED'}"
		 class="progress-box"
		 fxFlex="auto" fxLayoutAlign="center center">
		<div>{{stop?.statusDescription === 'CANCELED' ? 'Canceled' : 'trackOrderDetailsView.deliveredLabel' | translate}}
			<div class="small-text">
				<div *ngIf="stop?.delivered?.formattedDate">
					{{stop?.delivered?.formattedDate}} {{stop?.delivered?.formattedTime}} {{stop?.delivered?.timeZone}}
				</div>
				<div *ngIf="!stop?.delivered?.formattedDate && !stop?.deliverEta?.formattedDate">
					{{stop?.statusDescription !== 'CANCELED' && user?.globalSettings?.customMessageForNullDelivered ? user?.globalSettings?.customMessageForNullDelivered : 'N/A'}}
				</div>
				<div *ngIf="!stop?.delivered?.formattedDate && stop?.deliverEta?.formattedDate && user?.token">
					ETA: {{stop?.deliverEta?.formattedDate}} {{stop?.deliverEta?.formattedTime}} {{stop?.deliverEta?.timeZone}}
				</div>
			</div>
		</div>
	</div>
</div>
